var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Test Messenger Layout"}},[_c('m-messenger-layout',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('m-conversation-summaries',{ref:"summary_pane"})]},proxy:true}])},[_c('m-conversation',{ref:"conversation_pane"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }